import {
  API_ENDPOINT,
  useClientApiV1MockInterviewsNoLimitCreateMutation,
} from '../../resources/@types/studyAgentSchema';

interface UseClientV1MockInterviewsNoLimitCreateMutation {
  options?: Parameters<typeof useClientApiV1MockInterviewsNoLimitCreateMutation>[0]['options'];
}

export function useMockInterviewNoLimitCreateMutation({
  options,
}: UseClientV1MockInterviewsNoLimitCreateMutation) {
  return useClientApiV1MockInterviewsNoLimitCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_MOCK_INTERVIEWS_NO_LIMIT,
    options,
  });
}
